import { render, staticRenderFns } from "./MoleculeEditionAssetComments.vue?vue&type=template&id=f41cdb34&"
import script from "./MoleculeEditionAssetComments.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAssetComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports